import React from 'react';
import {
  ArrayField,
  Datagrid,
  NumberField,
  ReferenceField,
  TextField,
  useRecordContext,
} from 'react-admin';
import { QuickbooksPriceField } from '../components/QuickbooksPriceField';
import { QuickbooksItemLine } from '../types';

export const QbLinesFields = () => {
  const record = useRecordContext();
  if (record && record.Line)
    record.Line = record.Line.filter((line: QuickbooksItemLine) => !!line.Id);

  return (
    <ArrayField source="Line">
      <Datagrid bulkActionButtons={false}>
        <ReferenceField
          source="SalesItemLineDetail.ItemRef.value"
          reference="items"
        >
          <TextField source="Name" />
        </ReferenceField>

        <TextField source="Description" />

        <ReferenceField
          source="SalesItemLineDetail.ItemRef.value"
          reference="items"
        >
          <TextField source="Type" />
        </ReferenceField>
        <QuickbooksPriceField source="SalesItemLineDetail.UnitPrice" />
        <NumberField source="SalesItemLineDetail.Qty" />
        <QuickbooksPriceField source="Amount" />
        <ReferenceField
          source="SalesItemLineDetail.TaxCodeRef.value"
          reference="taxes"
        >
          <TextField source="Name" />
        </ReferenceField>
      </Datagrid>
    </ArrayField>
  );
};
